/* tslint:disable */
/* eslint-disable */
import { InstitutionDisplayModel as AceXFoundPortalCoreCaqModelsInstitutionDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/institution-display-model';
import { GlobalEnumsAceBenutzerrolle as AceXFoundPortalCoreEntitiesGlobalEnumsAceBenutzerrolle } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-benutzerrolle';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { InstitutionDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsInstitutionDisplayModelFormGroup } from '@/api/model-index';

export interface IUserDisplayModel {
  benutzerrolle?: AceXFoundPortalCoreEntitiesGlobalEnumsAceBenutzerrolle;
  externerBenutzerId?: string;
  firstname?: null | string;
  institution?: AceXFoundPortalCoreCaqModelsInstitutionDisplayModel;
  institutionId?: string;
  lastname?: null | string;
  username?: null | string;
}
export class UserDisplayModel extends BaseModel implements IUserDisplayModel {
  benutzerrolle?: AceXFoundPortalCoreEntitiesGlobalEnumsAceBenutzerrolle;
  externerBenutzerId?: string;
  firstname?: null | string;
  institution?: AceXFoundPortalCoreCaqModelsInstitutionDisplayModel;
  institutionId?: string;
  lastname?: null | string;
  username?: null | string;
}
class BaseUserDisplayModelFormGroup extends FormGroup {
  private static _instance: UserDisplayModelFormGroup;
  
  public static get Instance(): UserDisplayModelFormGroup {
    this._instance = new UserDisplayModelFormGroup({
      benutzerrolle: new FormControl(null),
      externerBenutzerId: new FormControl(null),
      firstname: new FormControl(null),
      institution: AceXFoundPortalCoreCaqModelsInstitutionDisplayModelFormGroup.Instance,
      institutionId: new FormControl(null),
      lastname: new FormControl(null),
      username: new FormControl(null),
    });

    return this._instance;
  }
}


export class UserDisplayModelFormGroup extends BaseUserDisplayModelFormGroup {
  public get Benutzerrolle(): FormControl {
    return this.controls["benutzerrolle"] as FormControl;
  }
  public get ExternerBenutzerId(): FormControl {
    return this.controls["externerBenutzerId"] as FormControl;
  }
  public get Firstname(): FormControl {
    return this.controls["firstname"] as FormControl;
  }
  public get Institution(): AceXFoundPortalCoreCaqModelsInstitutionDisplayModelFormGroup {
    return this.controls["institution"] as AceXFoundPortalCoreCaqModelsInstitutionDisplayModelFormGroup;
  }
  public get InstitutionId(): FormControl {
    return this.controls["institutionId"] as FormControl;
  }
  public get Lastname(): FormControl {
    return this.controls["lastname"] as FormControl;
  }
  public get Username(): FormControl {
    return this.controls["username"] as FormControl;
  }
  

}

export module UserDisplayModelForm
  {
    export class FormFields
    {
      static _benutzerrolle: string = "benutzerrolle";
      static _externerBenutzerId: string = "externerBenutzerId";
      static _firstname: string = "firstname";
      static _institution: string = "institution";
      static _institutionId: string = "institutionId";
      static _lastname: string = "lastname";
      static _username: string = "username";
    }
  }

